import { render, staticRenderFns } from "./SectionsOfdashboard.vue?vue&type=template&id=0aef4cf3&scoped=true&"
import script from "./SectionsOfdashboard.ts?vue&type=script&lang=ts&"
export * from "./SectionsOfdashboard.ts?vue&type=script&lang=ts&"
import style0 from "./SectionsOfdashboard.scss?vue&type=style&index=0&id=0aef4cf3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aef4cf3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDialog,VIcon,VProgressCircular,VRow,VTextField})
